import Config from '../launch/config'

export const getFactionTextColor = (faction) => {
    let headingColor = 'ffffff'

    if (faction === Config.userFactionName) {
        headingColor = Config.colorGreen
    }

    if (faction === Config.enemyFactionName) {
        headingColor = Config.colorRed
    }

    return headingColor
}
